import COUNTRIES from '../countries.translations'

import translations from './chromium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/chromium'

export const chromium: Metal = {
  id: 8,
  slug: 'chromium',
  name: t.name,
  symbol: 'Cr',
  // Coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Bushveld Igneous Complex, chromium mines (South Africa)',
      region: t.mine0Region,
      slug: 'bushveld-igneous-complex',
      coordinates: [27.62, -25.72],
    },
    {
      name: 'Khromtau, chromium mine (Kazakhstan)',
      region: t.mine1Region,
      slug: 'khromtau',
      coordinates: [58.43, 50.26],
    },
    {
      name: 'Kemi, chromium mine (Finland)',
      region: t.mine2Region,
      slug: 'kemi',
      coordinates: [24.56, 65.74],
    },
    {
      name: 'Sukinda, chromium mine (India)',
      region: t.mine3Region,
      slug: 'sukinda',
      coordinates: [85.76, 21.03],
    },
    {
      name: 'Guleman, chromium mine (Turkey)',
      region: t.mine4Region,
      slug: 'guleman',
      coordinates: [39.42, 38.44],
    },
    {
      name: 'Great Dyke, chromium mines (Zimbabwe)',
      region: t.mine5Region,
      slug: 'great-dyke',
      coordinates: [30.2, -18.4],
    },
  ],
  countries: [
    { name: COUNTRIES.southAfrica, percent: 44.7 },
    { name: COUNTRIES.turkey, percent: 17 },
    { name: COUNTRIES.kazakhstan, percent: 13.8 },
    { name: COUNTRIES.india, percent: 8.7 },
    { name: COUNTRIES.finland, percent: 4 },
  ],
  // South African chromite also comes out of platinum-group mining waste.
  related: ['palladium', 'platinum', 'ruthenium'],
  content: {
    smartphone: {
      quantityScore: 3,
      quantityLabel: t.smartphone.label,
      parts: ['casing'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 3, ...t.supplyRisk },
    recycling: { score: 3, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
